window.isFrenzyEventApiCall = true;

  // Rivo: one debounced re-init shared by every call site below.
  window.rivoReinitFavorites = (function () {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var widget = document.getElementById('rivo-account-slideout');
        if (!window.RivoProfileAlpine || !widget) return;
        try {
          window.RivoProfileAlpine.$data(widget)?.initializeFavoriteButtons();
        } catch (e) {
          console.warn('Rivo re-init failed:', e);
        }
      }, 120);
    };
  })();

   function closeSuggestion(){
        document.querySelector('.frenzy_mobile_search_input_clear_button').addEventListener("click", function () {
            document.querySelector('body').classList.remove('search-event');
        });
       document.querySelector('.frenzy_mobile_search_input_clear_button').addEventListener("touchstart", function () {
            document.querySelector('body').classList.remove('search-event');
        });
       if(document.querySelector('.frenzy_mobile_search_box_close_button')){
          document.querySelector('.frenzy_mobile_search_box_close_button').addEventListener("touchstart", function () {
              document.querySelector('body').classList.remove('search-event');
          });
       }
   }
   if(document.querySelectorAll('.frenzy_search_suggest').length > 0){
     document.querySelectorAll('.frenzy_search_suggest').forEach(function(this_click){
       this_click.addEventListener('click', function(){
         document.querySelector('body').classList.add('search-event');
         closeSuggestion();
       });
       this_click.addEventListener('touchstart', function(){
        document.querySelector('body').classList.add('search-event');
         closeSuggestion();
       });
     });    
   }
   $(".frenzy_search_suggest").on("click", function(){
       closeSuggestion();
       document.querySelector('body').classList.add('search-event');
   });

   // Remove search-event when user clicks outside the Frenzy search input or suggest box
   var searchEventOutsideSelector = '.frenzy_search_suggest, .frenzy-suggest-wrapper, .frenzy-search-input, .header-search-js-trigger, .header-search-js-frenzy-host';
   document.addEventListener('click', function(e) {
     if (!e.target.closest(searchEventOutsideSelector)) {
       document.body.classList.remove('search-event');
     }
   });
   document.addEventListener('touchstart', function(e) {
     if (!e.target.closest(searchEventOutsideSelector)) {
       document.body.classList.remove('search-event');
     }
   }, { passive: true });

let click_row_event = 0;
var collection_handle = '';
if(__st.p == 'collection'){
  collection_handle = __st.pageurl.split('/');
  collection_handle = collection_handle[2] ? collection_handle[2] : '';
}
window.FrenzyProductGridChangeCallBack = async function(html, data){
  var total_display_swatch_count = 5;
  if(data?.all_variant_swatch_1){
    if(data?.all_variant_swatch_1.length > total_display_swatch_count){
      var count_of_swatch = (5 - data?.all_variant_swatch_1.length);
      html.querySelector('.frenzy_product_swatch').insertAdjacentHTML('beforeend','<span class="frenzy_swatch_count"> +'+ Math.abs(count_of_swatch) +'</span>');
      (data?.all_variant_swatch_1 || []).map(function(x,y){
        if(y >= total_display_swatch_count){
          html.querySelector('.frenzy_product_swatch .frenzy_swatch_item[key="'+y+'"]').classList.add('swatch_hide');
        }
      })
    }
  }
  let org_product_tags = data.org_product_tags;
  let badge_id = '';
  let hide_badge = false;
  var badge_found = false;
  var s_badge_text = '';
  var s_badge_text_colors= '';
  var s_badge_background_color = '';
    org_product_tags = org_product_tags.reverse();
    org_product_tags.forEach(function(d,k){
    if(d.includes("badge_")){
      badge_id = d;
    }
  });
  
   
   
   
    

  if(meta_shop && badge_id){
    meta_shop.forEach(function(val,key){
    
     if(val.includes(badge_id)){
        badge_found = true;
        var ref = key;
        s_badge_text = badge_text[ref];
        s_badge_text_colors= badge_text_color[ref] ? badge_text_color[ref] : '#000';
        s_badge_background_color = badge_background_color[ref] ?  badge_background_color[ref] : "#ffffff";
        var collections_hidden = collections_hide_badge[ref] ? collections_hide_badge[ref] : '';
        collections_hidden = collections_hidden.split("|");
        var status = false;
        collections_hidden.forEach(function(s,k){
         if(s.includes(collection_handle) && __st.p == 'collection'){
           status = true;
         }
        })
         if(status){
            hide_badge = true;
         }
        return false;
     }
   });
  }
   if(badge_found && hide_badge != true){
    var s_html = '<div class="product-badge" style="color:'+s_badge_text_colors+'; background-color:'+s_badge_background_color+'">'+s_badge_text+'</div>';
    html.querySelector('.frenzy_product_tags').innerHTML = s_html;
   }

  var persistentNoteTag = org_product_tags.find(function(tag){ return tag.startsWith('persistent_note:'); });
  if(persistentNoteTag){
    var persistentNoteText = persistentNoteTag.slice('persistent_note:'.length);
    var persistentNoteHTML = '<div class="cart-persistent-note"><div class="cart-persistent-note__item" style="color: #030303;">' + persistentNoteText + '</div></div>';
    var itemDetail = html.querySelector('.frenzy_product_item_detail');
    if(itemDetail){
      itemDetail.insertAdjacentHTML('beforeend', persistentNoteHTML);
    }
  }

  let discountPercent = 0;
  if(window.theme.enableBfcm) {
    data.org_product_tags.forEach(tag => {
      if(discountPercent) return;
      
      const discountRegEx = /\bbadge_(\d+)off\b/.exec(tag);
      if(discountRegEx?.length) {
        discountPercent = discountRegEx[1];
        
        html.querySelector('.frenzy_product_price_compare').innerHTML = money_format_Frenzy(data.org_price * 100, frenzy_shop_currency);
        const salePriceElem = html.querySelector('.frenzy_product_price_sale');
        salePriceElem.innerHTML = money_format_Frenzy(data.org_price * 100 - (data.org_price * 100 * discountPercent / 100), frenzy_shop_currency);
        salePriceElem.classList.add('is-sale');
      }
    });
  }

  
  var product_handle =  data.org_prod_url.split("?");
  var product_id_variant =  data.product_id_variant.split("_");
  let handle = '';
  var images = data.org_image_url.split(" ");
  var image = images[0] ? images[0] : '';
  var v_title = '';
  var v_price = '';
  // jQuery.getJSON(window.Shopify.routes.root + 'products/'+product_handle[0]+'.js', function(product) {
    
  //   handle =  product.handle;
  //   var p =  product.variants;
  //   p.forEach(function(v_val,v_key){
  //     // if(product_id_variant[1] == v_val.id){
  //      if(v_key == 0){
  //         // console.log("v_val", v_val);
  //         product_id_variant = v_val.id;
  //         v_title = v_val.name;
  //         v_price = v_val.price;
  //        }
  //     // }   
  //   })
  // });
   if(data.smf_summaryData != null && data.smf_summaryData.length > 0){
     var summaryData = JSON.parse(data.smf_summaryData);
     var ReviewHTML = '';
     if(summaryData.reviewCount > 0){
           ReviewHTML =  '<div data-oke-star-ratting data-oke-reviews-product-id="shopify-'+data.product_id+'">'+data.smf_StarRatingSnippet+'</div>';
     }
     $(ReviewHTML).insertAfter(html.querySelector('.frenzy_product_title'));
   }
// --- Rivo wishlist hearts (replaces Zoomy zoomywishid injection) ---
  var rivoFigure = html.querySelector('figure');
  if (rivoFigure && !rivoFigure.querySelector('rivo-favorite-button')) {
    rivoFigure.insertAdjacentHTML('beforeend',
      '<div class="favorite-button-wrapper">' +
      '<rivo-favorite-button data-product-id="' + data.product_id + '" rivo-ax-data rivo-ax-cloak ' +
      'rivo-ax-html="$store.icons.heart" ' +
      'rivo-ax-show="$store.rivo_aw_settings?.favorites_enabled && (!$store.rivo_profile_customer || $store.loading_states.global_favorite_buttons)" ' +
      'aria-label="Add to favourites">' +
      '</rivo-favorite-button></div>');
    window.rivoReinitFavorites();
  }
  getFrenzyProductId();
}
window.frenzyCartCallBack = function(cart){
  // Cartography: open cart drawer and refresh content (theme listens for cart:update)
  document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart || {}, sourceId: 'frenzy-plp', data: {} } }));
  var drawer = document.querySelector('cart-drawer-component');
  if (drawer && typeof drawer.open === 'function') drawer.open();
}

const frenzyQuickAddClick = async(this_click) => {
  const productItem = this_click.closest(".frenzy_product_item");
  const frenzyContainer = productItem.closest(".frenzy_container");
  const prod_url = this_click.getAttribute('data-url');
  let frenzy_grid_quickbuy = window.location.origin+Shopify.routes.root+"products/" + prod_url + "?view=frenzy-productvariants";
  if(prod_url.includes('variant')){
    frenzy_grid_quickbuy = window.location.origin+Shopify.routes.root+"products/" + prod_url + "&view=frenzy-productvariants";
  }
  else{
    frenzy_grid_quickbuy = window.location.origin+Shopify.routes.root+"products/" + prod_url + "?view=frenzy-productvariants";
  }
  const response = await fetch(frenzy_grid_quickbuy, {
      method: "GET",
  });
  const result = await response.text();
  if(result){
    const new_HTML = new DOMParser().parseFromString(result, "text/html");
    const modalHTML = new_HTML.querySelector('.frenzy-productswatch').outerHTML;
    if(modalHTML){
      const buttonContainer = productItem.querySelector('figure .frenzy_product_item_action .frenzy_swatch');
      this_click.closest('.frenzy_product_item').classList.add('frenzy-grid-open');
      if(document.documentElement.clientWidth > 767){
        if(!buttonContainer.querySelector('.frenzy-productswatch')){
          buttonContainer.innerHTML = modalHTML;
          productItem.querySelectorAll(".frenzyModalCloseTrigger").forEach(function (this_click) {
            this_click.addEventListener("click", function (event) {
                this_click.closest('.frenzy_product_item').classList.remove('frenzy-grid-open');      
            });
          });
        }
      }else{
       const getHTML = this_click.closest('.frenzy_product_item').querySelector('.frenzy_product_item_action').innerHTML;
       const newDiv = document.querySelector(".frenzy_grid-details.frenzy_grid");
       const overlayDiv = document.querySelector(".frenzy_grid_details-overlay");
       newDiv.querySelector('.frenzy_mobile-details').innerHTML = getHTML;
       document.querySelector('.frenzy_grid-details .frenzy_swatch').innerHTML = modalHTML;
       document.body.classList.add('grid-popup-open');
      }
    }
  }
}

window.FrenzyBundleAfterDetailsCallBack = function(data,html){

  var total = 0;
  var whishlistHTML = '';
  (data || []).map((x, i) => {
    var product_handle =  x.org_prod_url.split("?");
    var product_id_variant =  x.product_id_variant.split("_");
    let handle = '';
    var images = x.org_image_url.split(" ");
    var image = images[0] ? images[0] : '';
    var v_title = '';
    var v_price = '';
    // jQuery.getJSON(window.Shopify.routes.root + 'products/'+product_handle[0]+'.js', function(product) {
    //   handle =  product.handle;
    //   var p =  product.variants;
    //   p.forEach(function(v_val,v_key){
    //      if(v_key == 0){
    //         product_id_variant = v_val.id;
    //         v_title = v_val.name;
    //         v_price = v_val.price;
    //        }
    //   })
    //   whishlistHTML = '<div class="zoomywishid zoomywishid-'+x.product_id+'" data-product-id="'+x.product_id+'" data-handle = "sariah-top-in-clover-field" data-image="'+image+'"  data-variantname="'+v_title+'" data-title="'+x.org_product+'" data-variant="'+product_id_variant+'" data-price="'+v_price+'"></div>';
    //   document.querySelector('.frenzy_bundle_product_grid[data-index="'+i+'"]').querySelector('.frenzy_bundle_product_grid_inner').insertAdjacentHTML('afterend',whishlistHTML);
    // });  
    let org_product_tags = x.org_product_tags;
    org_product_tags = org_product_tags.reverse();
      org_product_tags.forEach(function(d,k){
        if(window.theme.enableBfcm) {
        if(d.includes("badge_") && d.includes('off')){
           d = d.split('_');
           var discount_value = d[1];
           let discount_per = discount_value.replace('off', '');
          var price =  x.org_price * discount_per / 100;
          var org_price = x.org_price - price;
       
          if(d[1] != "new"){
            total += org_price;
            // console.log('...', document.querySelector('.frenzy_pb_details .frenzy_bundle_product_grid[data-index="'+i+'"]'));
            document.querySelector('.frenzy_pb_details .frenzy_bundle_product_grid[data-index="'+i+'"]').querySelector('.frenzy_bundle_product_main_price').innerHTML = '<span class="money">'+money_format_Frenzy(org_price * 100, frenzy_shop_currency)+'</span>';
            document.querySelector('.frenzy_pb_details .frenzy_bundle_product_grid[data-index="'+i+'"]').querySelector('.frenzy_bundle_product_main_price').classList.add('is-sale');
            var compare_price = '<span class="frenzy_bundle_product_compare_price"><span class="money">' +money_format_Frenzy(x.org_price * 100,frenzy_shop_currency) +"</span></span>";
              if(document.querySelector('.frenzy_pb_details .frenzy_bundle_product_grid[data-index="'+i+'"]').querySelector('.frenzy_bundle_product_compare_price')){
                document.querySelector('.frenzy_pb_details .frenzy_bundle_product_grid[data-index="'+i+'"]').querySelector('.frenzy_bundle_product_compare_price').innerHTML = '<span class="money">'+money_format_Frenzy(x.org_price * 100, frenzy_shop_currency)+'</span>';
              }else{
                document.querySelector('.frenzy_pb_details .frenzy_bundle_product_grid[data-index="'+i+'"]').querySelector('.frenzy_bundle_product_main_price').insertAdjacentHTML("afterend", compare_price);  
              } 
           }
        }
        }
      });
  });

  
if (total!=0 && !isNaN(total)){
  total = total*100;
  document.querySelector('.frenzy_bundle_final_total').innerHTML = '<span class="money">'+money_format_Frenzy(total, frenzy_shop_currency)+'</span>';}

  
}

window.frenzAfterApiCallBack = function(){
  document.querySelectorAll('.frenzy_product_item').forEach(function(item){
    var tagsEl = item.querySelector('[data-product-tags]');
    var tagsRaw = tagsEl ? tagsEl.getAttribute('data-product-tags') : '';
    var tags = tagsRaw ? tagsRaw.split(',').map(function(t){ return t.trim(); }) : [];
    var persistentNoteTag = tags.find(function(tag){ return tag.startsWith('persistent_note:'); });
    if(persistentNoteTag && !item.querySelector('.cart-persistent-note')){
      var persistentNoteText = persistentNoteTag.slice('persistent_note:'.length);
      var itemDetail = item.querySelector('.frenzy_product_item_detail');
      if(itemDetail){
        itemDetail.insertAdjacentHTML('beforeend', '<div class="cart-persistent-note"><div class="cart-persistent-note__item" style="color: #030303;">' + persistentNoteText + '</div></div>');
      }
    }
  });
    document.querySelector('.filter_type_scf_color')?.classList?.add('show_all');
     $('.filter_input_value').on('keypress', function(event) {
        if (event.which === 13) {
           $(this).parents('label[for="'+$(this).attr('id')+'"]').trigger('click');
        }
     });
  // if(click_row_event == 0){
  // setTimeout(function(){
  
  // },5000);
    click_row_event =  1;
  // }

  document.querySelectorAll('.frenzy_sw_nl_item a').forEach(function(this_click){
    this_click.addEventListener('focusin', function(e){
    console.log("ee...",e);
      if (!this_click.closest('.search_query_hover_function_0')) {
          console.log("ee...",e);
                const query =
                    e.target.parentElement.getAttribute("data-type");
    
                frenzyAutoSuggestClickEventsApi(
                    "suggest_query_hover",
                    "query",
                    query
                );
            }
    });
    });
  if(document.querySelectorAll('.frenzy_swatch_item a').length > 0){
    document.querySelectorAll('.frenzy_swatch_item a').forEach(function(this_click){
     this_click.addEventListener('mouseover', function(e){
        if(!this_click.classList.contains('.focus')){
         document.querySelectorAll('.frenzy_swatch_item a').forEach(function(target){
           target.classList.remove('focus');    
         }); 
        }
       var frenzy_img_first =  this_click.getAttribute('data-frenzy_img_first');
       var frenzy_img_second = this_click.getAttribute('data-frenzy_img_second');
       this_click.closest('.frenzy_product_item').querySelector('.frenzy_img_first').setAttribute('src',frenzy_img_first);
       if(frenzy_img_second != 'undefined'){
         this_click.closest('.frenzy_product_item').querySelector('.frenzy_img_second').setAttribute('src',frenzy_img_second);  
       }else{
         this_click.closest('.frenzy_product_item').querySelector('.frenzy_img_second').setAttribute('src',frenzy_img_first);
       }
       
       e.target.classList.add('focus');
     });
    this_click.addEventListener('focusin', function(e){
       document.querySelectorAll('.frenzy_swatch_item a').forEach(function(target){
         target.classList.remove('focus');    
       }); 
       var frenzy_img_first =  this_click.getAttribute('data-frenzy_img_first');
       var frenzy_img_second = this_click.getAttribute('data-frenzy_img_second');
       this_click.closest('.frenzy_product_item').querySelector('.frenzy_img_first').setAttribute('src',frenzy_img_first);
        if(frenzy_img_second != 'undefined'){
         this_click.closest('.frenzy_product_item').querySelector('.frenzy_img_second').setAttribute('src',frenzy_img_second);  
       }else{
         this_click.closest('.frenzy_product_item').querySelector('.frenzy_img_second').setAttribute('src',frenzy_img_first);
       }
     });
  })
  }
  getFrenzyProductId();
}

function wishlist_enterKey(product_id){
        setTimeout(function(){
          $('.frenzy_grid .checkbox-'+product_id).on('keypress', function(event) {
            event.preventDefault();
              if (event.which === 13) {
                $(this).trigger('click');
              }
           });
        },4000);
}
const searchIcon = document.querySelectorAll('.logo-area .feather-search,#main-nav .feather-search');
searchIcon.forEach((search) => {
  search.addEventListener('click', function(){
    var element = document.querySelector("body");
    element.classList.toggle("feather-search-open");
  });
});

// window.frenzyFilterClickCallBack = function(){
//   const element = document.querySelector('#main-content');
//   element.scrollIntoView({
//     block: "start",
//     behavior: 'auto'
//   });
// }

frenzy_auto_suggestion_close = '.bbH7WoqZY3ke7xCgZyKy';

function updateFrenzyProductItem($item, {
  provarId,
  proId,
  prodHandle,
  prodTtl,
  prodFirstimg,
  prodSecondimg,
  prodPrice,
  prodComparePrice,
  frenzy_shop_currency
}) {
  $item.find('.frenzy_add_to_cart_btn').attr('data-sku', provarId);
  $item.find('figure a').attr('data-sku', provarId);
  $item.attr({
    'data-id': provarId,
    'data-prod_id': proId,
    'data-handle': prodHandle
  });
  $item.find('.frenzy_product_title a')
    .text(prodTtl)
    .attr('href', `/products/${prodHandle}`);
  $item.find('figure a').attr('href', `/products/${prodHandle}`);
  if (prodFirstimg) {
    $item.find('.frenzy_img_first').attr('src', prodFirstimg);
  }
  if (prodSecondimg) {
    $item.find('.frenzy_img_second').attr('src', prodSecondimg);
  } else if (prodFirstimg) {
    $item.find('.frenzy_img_second').attr('src', prodFirstimg);
  }
  if (prodPrice) {
    $item.find('.frenzy_product_price_sale')
      .text(money_format_Frenzy(prodPrice, frenzy_shop_currency));
  }
  if (prodComparePrice && prodComparePrice > prodPrice) {
    $item.find('.frenzy_product_price_compare')
      .text(money_format_Frenzy(prodComparePrice, frenzy_shop_currency));
  }
}

function getFrenzyProductId() {
  $('.frenzy_grid').on('click', '.frenzy_product_item .swatch.color .swatch-element', function(event) {
    event.stopPropagation();
    event.preventDefault();
    $(this).find('.swatch-border').addClass('selected');
    $(this).siblings().find('.swatch-border').removeClass('selected');
    var varId = $(this).closest('.frenzy_product_item').find('.swatch.swatch-size .swatch-element .swatch-item.active').attr('data-varid');
    var proId = $(this).attr('product-id');
    var prodHandle = $(this).attr('data-handle');
    var prodTtl = $(this).attr('data-title');
    var prodPrice = $(this).attr('data-price');
    var prodComparePrice = $(this).attr('data-compareprice');
    var prodFirstimg = $(this).attr('data-mainimg');
    var prodSecondimg = $(this).attr('data-hoverimg');
    var variantIds = JSON.parse($(this).attr('data-color-variant-ids'));
    var provarId = '';
    if(varId != undefined){
      provarId = `${proId}_${varId}`;
    }else{
      provarId = `${proId}_${variantIds[0]}`;
    }
    var variantAvailability = JSON.parse($(this).attr('data-color-variant-availability'));
    let sizes = '';
    if($(this).closest('.frenzy_product_item').find('.swatch-size')){
      sizes = Array.from($(this).closest('.frenzy_product_item').find('.swatch-size .swatch-item'));
    }
   $(this).closest('.frenzy_product_item').find('.zoomywishid').attr('data-product-id',proId);
   $(this).closest('.frenzy_product_item').find('.zoomywishid').attr('data-handle',prodHandle);
   if(prodFirstimg) $(this).closest('.frenzy_product_item').find('.zoomywishid').attr('data-image',prodFirstimg);
   $(this).closest('.frenzy_product_item').find('.zoomywishid').attr('data-variant',varId);
   $(this).closest('.frenzy_product_item').find('.zoomywishid .zoomycheck').attr('data-product-id',proId);
   $(this).closest('.frenzy_product_item').find('rivo-favorite-button').attr('data-product-id',proId);
   window.rivoReinitFavorites();
    // Update sizes
      if(sizes.length > 0){
        sizes.forEach((size, i) => {
          size.dataset.varid = variantIds[i];
          if (!variantAvailability[i]) {
            size.closest('.swatch-element').classList.add("soldout");
          } else {
            size.closest('.swatch-element').classList.remove("soldout");
          }
        });
      }
    // $(this).closest('.frenzy_product_item').find('.frenzy_add_to_cart_btn').attr('data-sku',provarId);
    // $(this).closest('.frenzy_product_item').find('figure a').attr('data-sku',provarId);
    // $(this).closest('.frenzy_product_item').attr('data-id',provarId);
    // $(this).closest('.frenzy_product_item').attr('data-prod_id',proId);
    // $(this).closest('.frenzy_product_item').attr('data-handle',prodHandle);
    // $(this).closest('.frenzy_product_item').find('.frenzy_product_title a').text(prodTtl);
    // $(this).closest('.frenzy_product_item').find('.frenzy_product_title a').attr('href','/products/'+prodHandle);
    // if(prodFirstimg) $(this).closest('.frenzy_product_item').find('.frenzy_img_first').attr('src',prodFirstimg);
    // if(prodSecondimg) $(this).closest('.frenzy_product_item').find('.frenzy_img_second').attr('src',prodSecondimg);
    // $(this).closest('.frenzy_product_item').find('figure a').attr('href','/products/'+prodHandle);
    // if(prodPrice){
    //   $(this).closest('.frenzy_product_item').find('.frenzy_product_price_sale').text(money_format_Frenzy(prodPrice, frenzy_shop_currency))
    // }
    // if(prodComparePrice && prodComparePrice > prodPrice){
    //   $(this).closest('.frenzy_product_item').find('.frenzy_product_price_compare').text(money_format_Frenzy(prodComparePrice, frenzy_shop_currency))
    // }
    const $clickedItem = $(this).closest('.frenzy_product_item');
    updateFrenzyProductItem($clickedItem,{provarId,proId,prodHandle,prodTtl,prodFirstimg,prodSecondimg,prodPrice,prodComparePrice,frenzy_shop_currency});
    if(window.innerWidth < 767){
      const $frenzyGrid = $('.frenzy_grid').find(`.frenzy_product_item.frenzy-grid-open`).first();
      if ($frenzyGrid.length) {
        updateFrenzyProductItem($frenzyGrid,{provarId,proId,prodHandle,prodTtl,prodFirstimg,prodSecondimg,prodPrice,prodComparePrice,frenzy_shop_currency});
      }
    }
  });
  $('.frenzy_grid').on('click', '.frenzy_product_item .swatch.swatch-size .swatch-element .swatch-item', function(event) {
      $(this).addClass('active');
      $(this).closest('.swatch-element').siblings().find('.swatch-item').removeClass('active');
      var proId = $(this).closest('.frenzy_product_item').find('.swatch.color .swatch-element .swatch-border.selected').closest('.swatch-element').attr('product-id');
      var varId = $(this).attr('data-varid');
      var provarId = `${proId}_${varId}`;
      $(this).closest('.frenzy_product_item').find('.frenzy_add_to_cart_btn').attr('data-sku',provarId)
      $(this).closest('.frenzy_product_item').find('figure a').attr('data-sku',provarId)
      $(this).closest('.frenzy_product_item').attr('data-id',provarId)
      $(this).closest('.frenzy_product_item').attr('data-prod_id',proId)
     $(this).closest('.frenzy_product_item').find('.zoomywishid').attr('data-variant',varId);
  });
}

document.addEventListener("click", function(event) {
  if (event.target.closest(".frenzy_grid_details-overlay , .frenzy_mobile-details .frenzy_product_buttom .frenzy_product_option button , .frenzy_mobile-details .frenzy_add_to_cart_btn, .frenzyModalCloseTrigger")) {
    document.body.classList.remove("grid-popup-open");
    if(window.innerWidth < 767){
      document.querySelectorAll('.frenzy_grid .frenzy_product_item').forEach((grid) => {
        if(grid.classList.contains('frenzy-grid-open')){
          grid.classList.remove('frenzy-grid-open');
        }
      });
    }
  }
});

// document.onreadystatechange = function () {
//     if (document.readyState === 'interactive') {
//     function isLastDigitEvenOrOdd(userId) {
//       const hexOnly = userId.replace(/[^0-9a-fA-F]/g, '');
//       const lastHexChar = hexOnly.slice(-1).toLowerCase();
//       const decimal = parseInt(lastHexChar, 16);
//       if (isNaN(decimal)) {
//         console.log("No valid hex digit found.");
//         return '';
//       }
//       return decimal % 2 === 0 ? "Even" : "Odd";
//     }
//     const newUserId = user_id_Frenzy != '' ? user_id_Frenzy.toString() : getFrenzyCookie('__attentive_session_id');
//     const isEvenOdd = isLastDigitEvenOrOdd(newUserId);

//     const isEvenTopCode = `<div class="frenzy_most_clicked_skus_section" config_id="0d1343cf-37a2-4361-90f7-14c990ffef45"></div>`;
//     const isEvenBottomCode = `<div class="frenzy_most_clicked_skus_section" config_id="94f5a8e5-1206-435e-8d6b-bde4f29f0744"></div>`;
//     const isODDTopCode = `<div class="frenzy_recommendation_section" config_id="ed5f46ee-5e98-4fa5-a6e3-9b23763a7cbf"></div>`;
//     const isODDBottomCode = `<div class="frenzy_recommendation_section" config_id="28b04cbc-dd30-4525-84af-cd288017eb91"></div>`;

//     if(__st && __st.p === 'home'){
//       var carouselOdd = document.querySelector('.frenzy-carousel_odd .section-custom__liquid');
//       var carouselEven = document.querySelector('.frenzy-carousel_even .section-custom__liquid');
//       if (carouselOdd && carouselEven) {
//       if(isEvenOdd == 'Even'){
//         carouselOdd.innerHTML = isEvenTopCode;
//         carouselEven.innerHTML = isODDBottomCode;
//       }else{
//         carouselOdd.innerHTML = isODDTopCode;
//         carouselEven.innerHTML = isEvenBottomCode;
//       }

//       document.querySelectorAll('.frenzy_most_clicked_skus_section').forEach(function (self, index) {
//         const frenzyApiName = "most_clicked_skus_carousel";
//         const sectionIndex = index + 1;
//         const swiperContainerClass = frenzyApiName + '-' + sectionIndex;
//         self.classList.add(swiperContainerClass);
//         const frenzy_recommendation_section_config = self.getAttribute("config_id") ? self.getAttribute("config_id") : null;
//         const frenzy_recommendation_section_ABTest_id = self.getAttribute("data-ab_test_id") ? self.getAttribute("data-ab_test_id") : null;
//         var data_json = JSON.stringify({
//             user_id: newUserId != '' ? newUserId?.toString() : null,
//             page: __st.p,
//             shop: frenzyShop,
//             num_matching: 15,
//             full_description: true,
//             config_id: frenzy_recommendation_section_config,
//             ab_test_id: frenzy_recommendation_section_ABTest_id,
//             currency: Shopify?.currency?.active ? Shopify?.currency?.active : '',
//             country: Shopify.country ? Shopify.country : '',
//             state: frenzy_state ? frenzy_state : null,
//             company_id: frenzy_company_id ? frenzy_company_id : null,
//             location_id: frenzy_location_id ? frenzy_location_id : null
//         });
//         const frenzy_recom_api = '/most-clicked-skus';
//         getRecommendationAPIWithStructure(data_json, frenzy_recom_api, self, frenzyApiName, sectionIndex);
//       });

//       document.querySelectorAll('.frenzy_recommendation_section').forEach(function (self, index) {
//         const frenzyApiName = "personalized_homepage_carosuel";
//         const sectionIndex = index + 1;
//         const swiperContainerClass = frenzyApiName + '-' + sectionIndex;
//         self.classList.add(swiperContainerClass);
//         if (self.getAttribute('data-variantID')) {
//             variant_id_Frenzy = self.getAttribute('data-variantID');
//         }
//         if (product_id_Frenzy && variant_id_Frenzy) {
//             frenzy_sku = product_id_Frenzy + "_" + variant_id_Frenzy;
//         }
//         const frenzy_recommendation_section_config = self.getAttribute("config_id") ? self.getAttribute("config_id") : null;
//         const frenzy_recommendation_section_ABTest_id = self.getAttribute("data-ab_test_id") ? self.getAttribute("data-ab_test_id") : null;
//         var data_json = JSON.stringify({
//             user_id: newUserId != '' ? newUserId?.toString() : null,
//             page: __st.p,
//             shop: frenzyShop,
//             num_matching: 15,
//             full_description: true,
//             config_id: frenzy_recommendation_section_config,
//             ab_test_id: frenzy_recommendation_section_ABTest_id,
//             currency: Shopify?.currency?.active ? Shopify?.currency?.active : '',
//             country: Shopify.country ? Shopify.country : null,
//             state: frenzy_state ? frenzy_state : null,
//             company_id: frenzy_company_id ? frenzy_company_id : null,
//             location_id: frenzy_location_id ? frenzy_location_id : null
//         });
//         getRecommendationAPIWithStructure(data_json, frenzy_recom_api, self, frenzyApiName, sectionIndex);
//       });
//       }
//     }
//   }
// };

// ADA changes
document.addEventListener("DOMContentLoaded", () => {
  let activeModal = null;
  let isTransitioning = false;
  let lastFocusedElement = null;

  /* ===============================
     CLOSE ALL MODALS
  =============================== */
  function forceCloseAll() {
    const allWrappers = document.querySelectorAll('.frenzy-suggest-wrapper');
    
    allWrappers.forEach(wrapper => {
      wrapper.classList.remove('open');
      wrapper.setAttribute('aria-hidden', 'true');
    });
    
    activeModal = null;
  }

  /* ===============================
     OPEN SPECIFIC MODAL
  =============================== */
  function openSpecificModal(targetModal) {
    if (!targetModal) return;
    
    // If already active, ensure it's open
    if (activeModal === targetModal && targetModal.classList.contains('open')) {
      return;
    }
    
    isTransitioning = true;
    
    // Close all other modals first
    const allWrappers = document.querySelectorAll('.frenzy-suggest-wrapper');
    allWrappers.forEach(wrapper => {
      if (wrapper !== targetModal) {
        wrapper.classList.remove('open');
        wrapper.setAttribute('aria-hidden', 'true');
      }
    });
    
    // Set as active
    activeModal = targetModal;
    
    // Open the target modal
    targetModal.classList.add('open');
    targetModal.setAttribute('aria-hidden', 'false');
    
    // Ensure modal is focusable
    if (!targetModal.hasAttribute('tabindex')) {
      targetModal.setAttribute('tabindex', '-1');
    }
    
    // Focus after DOM updates
    requestAnimationFrame(() => {
      const focusableElements = targetModal.querySelectorAll(
        'a[href]:not([disabled]), button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      
      let focused = false;
      
      // Try to focus first visible focusable element
      for (const element of focusableElements) {
        if (element.offsetParent !== null) {
          element.focus();
          focused = true;
          break;
        }
      }
      
      // Fallback to modal itself
      if (!focused) {
        targetModal.focus();
      }
      
      // Clear transition flag
      setTimeout(() => {
        isTransitioning = false;
      }, 100);
    });
  }

  /* ===============================
     CHECK IF ELEMENT IS INSIDE MODAL
  =============================== */
  function getContainingModal(element) {
    if (!element) return null;
    return element.closest('.frenzy-suggest-wrapper[aria-modal="true"]');
  }

  /* ===============================
     FOCUS MONITORING - Key Fix Here
  =============================== */
  document.addEventListener('focusin', (e) => {
    // Skip during transitions
    if (isTransitioning) return;
    
    const focusedElement = e.target;
    const focusedModal = getContainingModal(focusedElement);
    
    // Focus moved inside a modal
    if (focusedModal) {
      // If it's a different modal than the active one, switch to it
      if (activeModal !== focusedModal) {
        openSpecificModal(focusedModal);
      }
    } else {
      // Focus moved OUTSIDE all modals - close active modal
      if (activeModal) {
        // Small delay to prevent premature closing during navigation
        setTimeout(() => {
          const currentlyFocused = document.activeElement;
          const currentModal = getContainingModal(currentlyFocused);
          
          // Only close if focus is still outside
          if (!currentModal && activeModal) {
            forceCloseAll();
          }
        }, 50);
      }
    }
  }, true);

  /* ===============================
     ESCAPE KEY
  =============================== */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' || e.key === 'Esc') {
      if (activeModal) {
        forceCloseAll();
        e.preventDefault();
        e.stopPropagation();
      }
    }
  });

  /* ===============================
     CLICK OUTSIDE
  =============================== */
  document.addEventListener('mousedown', (e) => {
    if (!activeModal) return;
    
    const clickedModal = getContainingModal(e.target);
    const clickedTrigger = e.target.closest('[data-frenzy-open]');
    
    // Close if clicked outside modal and not on a trigger
    if (!clickedModal && !clickedTrigger) {
      forceCloseAll();
    }
  });

  /* ===============================
     TRIGGER BUTTONS
  =============================== */
  function setupTriggers() {
    document.querySelectorAll('[data-frenzy-open]').forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const targetSelector = trigger.dataset.frenzyOpen;
        if (!targetSelector) return;
        
        // Find the specific modal in the same context as the trigger
        const triggerStickyNav = trigger.closest('.stickynav, .nav-row.stickynav, #main-nav');
        const triggerHeader = trigger.closest('header');
        
        let targetModal = null;
        const allMatchingModals = document.querySelectorAll(targetSelector);
        
        if (triggerStickyNav) {
          // Find modal in same sticky nav
          for (const modal of allMatchingModals) {
            const modalStickyNav = modal.closest('.stickynav, .nav-row.stickynav, #main-nav');
            if (modalStickyNav === triggerStickyNav) {
              targetModal = modal;
              break;
            }
          }
        } else if (triggerHeader) {
          // Find modal in same header (but not in sticky nav)
          for (const modal of allMatchingModals) {
            const modalHeader = modal.closest('header');
            const modalStickyNav = modal.closest('.stickynav, .nav-row.stickynav, #main-nav');
            
            if (modalHeader === triggerHeader && !modalStickyNav) {
              targetModal = modal;
              break;
            }
          }
        }
        
        // Fallback to first match
        if (!targetModal && allMatchingModals.length > 0) {
          targetModal = allMatchingModals[0];
        }
        
        if (targetModal) {
          openSpecificModal(targetModal);
        }
      });
    });
  }
  
  setupTriggers();
  
  /* ===============================
     CLEANUP ON PAGE LOAD
  =============================== */
  forceCloseAll();
});

// Expose for Frenzy plugin (script uses const, so not on window by default)
if (typeof frenzyQuickAddClick !== 'undefined') window.frenzyQuickAddClick = frenzyQuickAddClick;

  window.addEventListener("klaviyoForms", function(e) {
    if (e?.detail?.type === "submit") {
      const getUserEmail = e?.detail?.metaData?.$email;
      const regEmailPayload = {
        email: getUserEmail ? getUserEmail : null,
        user_id: user_id_Frenzy != '' ? user_id_Frenzy?.toString() : null
      }
      if(getUserEmail){
        frenzyEmailWidgetEventApi(regEmailPayload,'register-email');  
      }
    }
  });

